export const REGION = 'region';
export const REGION_ID = 'region_id';
export const STORE_CODE = 'store_code';
export const STORE = 'store';
export const GAD_SOURCE = 'gad_source';
export const GCLID = 'gclid';
export const SRSLTID = 'srsltid';
